// Original course-cover assets in public/course-images, keyed by stable course id.
// Keep Chengetai workstation duplicates out of the learner-facing asset map.
export const COURSE_COVERS = {
  'civils2000-claude-professionals': '/course-images/cover-civils2000-claude-professionals.svg',
  'ai-microsoft-office': '/course-images/cover-msoffice.svg',
  'safe-ai-compliance': '/course-images/cover-compliance.svg',
  'ai-reporting-analysis': '/course-images/cover-reporting.svg',
  'prompt-mastery': '/course-images/cover-prompt.svg',
  'mastering-claude-ai': '/course-images/cover-claude.svg',
  'claude-skills': '/course-images/cover-claude-skills.png',
  'claude-code': '/course-images/cover-claude-code.png',
  'claude-cowork': '/course-images/cover-claude-cowork.png',
  'claude-design': '/course-images/cover-claude-design.png',
  'sharepoint-business': '/course-images/cover-sp.svg',
  'dynamics-365-crm': '/course-images/cover-d365.svg',
  'complete-github-course': '/course-images/cover-complete-github-course.svg',
  'anti-hacking-foundation': '/course-images/cover-anti-hacking-foundation.svg',
  'bbbee-masterclass': '/course-images/cover-bbbee-masterclass.svg',
  'esg-foundations-reporting': '/course-images/cover-esg-foundations-reporting.svg',
  'intro-to-ai': '/course-images/cover-intro-to-ai.svg',
  'bbbee-awareness-halfday': '/course-images/cover-bbbee-awareness-halfday.svg',
  'bbbee-professional-3day': '/course-images/cover-bbbee-professional-3day.svg',
  'esg-fullday-practitioner': '/course-images/cover-esg-fullday-practitioner.svg',
  'esg-professional-3day': '/course-images/cover-esg-professional-3day.svg',
  'employment-equity-committee': '/course-images/cover-employment-equity-committee.svg',
  'employment-equity-training': '/course-images/cover-employment-equity-training.svg',
  'skills-development-wsp-atr': '/course-images/cover-skills-development-wsp-atr.svg',
  'chatgpt-for-professionals': '/course-images/cover-chatgpt-for-professionals.svg',
  'chatgpt-custom-gpts': '/course-images/cover-chatgpt-custom-gpts.svg',
  'chatgpt-advanced-data-analysis': '/course-images/cover-chatgpt-advanced-data-analysis.svg',
  'chatgpt-canvas-projects': '/course-images/cover-chatgpt-canvas-projects.svg',
  'chatgpt-image-design': '/course-images/cover-chatgpt-image-design.svg',
  'mastering-chatgpt': '/course-images/cover-mastering-chatgpt.svg',
  'microsoft-copilot-365': '/course-images/cover-microsoft-copilot-365.svg',
  'ai-excel-mastery': '/course-images/cover-ai-excel-mastery.svg',
  'ai-powerpoint-mastery': '/course-images/cover-ai-powerpoint-mastery.svg',
  'finance-for-non-finance-managers': '/course-images/cover-finance-for-non-finance-managers.svg',
};

// These two catalogue courses have no matching original cover in public/course-images.
export const COURSE_COVER_FALLBACKS = [
  'credit-analysis-lending-deal-structuring',
  'work-readiness-programme',
];

export function courseCoverFor(courseId) {
  return COURSE_COVERS[courseId] || null;
}
